import { render, staticRenderFns } from "./BasicDataText.vue?vue&type=template&id=c889e06e&"
import script from "./BasicDataText.vue?vue&type=script&lang=js&"
export * from "./BasicDataText.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports